/**
 * Section Pattern 6 – Scroll Opacity Animation
 */

document.addEventListener('DOMContentLoaded', () => {

    /** ---------------- CONFIGURABLE VARIABLES ---------------- **/
    const blockSelector       = '.section-pattern-6-block';
    const animationClass       = 'is-in-view';        // Class added when item is visible
    const itemSelector         = '.wp-block-accordion-item';
    const rootMargin           = '-15% 0px -18% 0px'; // Start fade in/out slightly before fully visible
    const thresholds           = [0, 0.1, 0.2, 0.3];  // Multiple thresholds for smoother detection
    /** -------------------------------------------------------- **/

    // Select all relevant blocks
    const blocks = document.querySelectorAll(`${blockSelector} .scroll-opacity-animation`);
    if (!blocks.length) return; // Exit early if nothing found

    // IntersectionObserver options
    const observerOptions = {
        root: null,       // viewport
        rootMargin: rootMargin,
        threshold: thresholds
    };

    // Observer callback: toggle animation class based on visibility
    const observerCallback = (entries) => {
        entries.forEach(entry => {
            if (!entry.target) return;

            if (entry.isIntersecting) {
                entry.target.classList.add(animationClass);
            } else {
                entry.target.classList.remove(animationClass);
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Loop through each block and observe each item
    blocks.forEach(block => {
        const items = block.querySelectorAll(itemSelector);
        if (!items.length) return; // Skip if no items found

        items.forEach(item => {
            observer.observe(item);
        });
    });

});